<template>
  <md-toolbar
    id="toolbar"
    md-elevation="0"
    class="md-default md-absolute"
    :class="extraNavClasses"
    :color-on-scroll="colorOnScroll"
  >
    <div class="md-toolbar-row md-collapse-lateral">
      <div class="md-toolbar-section-start">
        <!-- <h3 class="md-title">Life Nutrition</h3> -->
        <router-link :to="{ name: 'index', params: {}}">
          <img class="md-image" :src="logo_img" alt="Logo" />
        </router-link>
      </div>
      <div class="md-toolbar-section-end">
        <md-button
          class="md-just-icon md-simple md-toolbar-toggle"
          :class="{ toggled: toggledClass }"
          @click="toggleNavbarMobile()"
        >
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </md-button>

        <div class="md-collapse">
          <div class="md-collapse-wrapper">
            
            <mobile-menu nav-mobile-section-start="false">
              <!-- Here you can add your items from the section-start of your toolbar -->
              <md-list-item class="menu-item">
                <router-link :to="{ name: 'products', params: {}}">
                  <div>{{ $t("产品") }}</div>
                </router-link>
              </md-list-item>

              <!-- <md-list-item class="menu-item">
                <router-link :to="{ name: 'products', params: {}}">
                  <div>关于我们</div>
                </router-link>
              </md-list-item> -->

              <md-list-item class="menu-item">
                <div @click="logout">{{ $t("登出") }}</div>
              </md-list-item>
            </mobile-menu>

            <md-list @click="toggleNavbarMobile">
              <md-list-item class="menu-item">
                <router-link :to="{ name: 'products', params: {}}">
                  <div>{{ $t("产品") }}</div>
                </router-link>
              </md-list-item>

              <!-- <md-list-item class="menu-item">
                <router-link :to="{ name: 'products', params: {}}">
                  <div>关于我们</div>
                </router-link>
              </md-list-item> -->

              <md-list-item class="menu-item">
                <router-link :to="{ name: 'cart', params: {}}">
                  <div>{{ $t("购物车") }}</div>
                </router-link>
              </md-list-item>

              <md-list-item class="menu-item" v-if="is_login">
                <router-link :to="{ name: 'orders', params: {}}">
                  <div>{{ $t("訂單") }}</div>
                </router-link>
              </md-list-item>

              <md-list-item class="menu-item" v-if="is_login">
                <router-link :to="{ name: 'member_profile', params: {}}">
                  <div>{{ $t("會員") }}</div>
                </router-link>
              </md-list-item>

              <md-list-item class="menu-item" v-if="is_login">
                <a class="cursor_pointer">
                  <div @click="logout">{{ $t("登出") }}</div>
                </a>
              </md-list-item>

              <md-list-item class="menu-item" v-if="!is_login">
                <router-link :to="{ name: 'login', params: {}}">
                  <div>{{ $t("登入") }}</div>
                </router-link>
              </md-list-item>

              <!-- <md-list-item class="menu-item">
                <a class="cursor_pointer">
                  <div @click="changeLang('zh')">繁</div>
                </a>
                <div class="cursor_pointer" style="padding: 0px 3px;">|</div>
                <a class="cursor_pointer">
                  <div @click="changeLang('cn')">簡</div>
                </a>
                <div class="cursor_pointer" style="padding: 0px 3px;">|</div>
                <a class="cursor_pointer">
                  <div @click="changeLang('en')">Eng</div>
                </a>
              </md-list-item> -->
            </md-list>
          </div>
        </div>
      </div>
    </div>
  </md-toolbar>
</template>

<script>
let resizeTimeout;
function resizeThrottler(actualResizeHandler) {
  // ignore resize events as long as an actualResizeHandler execution is in the queue
  if (!resizeTimeout) {
    resizeTimeout = setTimeout(() => {
      resizeTimeout = null;
      actualResizeHandler();

      // The actualResizeHandler will execute at a rate of 15fps
    }, 66);
  }
}

import MobileMenu from "@/layout/MobileMenu";
export default {
  components: {
    MobileMenu
  },
  props: {
    type: {
      type: String,
      default: "white",
      validator(value) {
        return [
          "white",
          "default",
          "primary",
          "danger",
          "success",
          "warning",
          "info"
        ].includes(value);
      }
    },
    colorOnScroll: {
      type: Number,
      default: 0
    },
    logo_img: {
      type: String,
      default: require("@/assets/img/ln/logo_small.png")
    }
  },
  data() {
    return {
      extraNavClasses: "",
      toggledClass: false,
      is_login : false,
      eventHub : window.eventHub,
    };
  },
  computed: {
    showDownload() {
      const excludedRoutes = ["login", "landing", "profile"];
      return excludedRoutes.every(r => r !== this.$route.name);
    }
  },
  methods: {
    changeLang(lang){
      this.$i18n.locale = lang;
    },
    logout(){
      
      localStorage.removeItem('member_id');
      localStorage.removeItem('member_token');
      this.is_login = false;
      
      this.$router.replace("/");
    },

    bodyClick() {
      let bodyClick = document.getElementById("bodyClick");

      if (bodyClick === null) {
        let body = document.querySelector("body");
        let elem = document.createElement("div");
        elem.setAttribute("id", "bodyClick");
        body.appendChild(elem);

        let bodyClick = document.getElementById("bodyClick");
        bodyClick.addEventListener("click", this.toggleNavbarMobile);
      } else {
        bodyClick.remove();
      }
    },
    toggleNavbarMobile() {
      this.NavbarStore.showNavbar = !this.NavbarStore.showNavbar;
      this.toggledClass = !this.toggledClass;
      this.bodyClick();
    },
    handleScroll() {
      let scrollValue =
        document.body.scrollTop || document.documentElement.scrollTop;
      let navbarColor = document.getElementById("toolbar");
      this.currentScrollValue = scrollValue;
      if (this.colorOnScroll > 0 && scrollValue > this.colorOnScroll) {
        this.extraNavClasses = `md-${this.type}`;
        navbarColor.classList.remove("md-primary");
      } else {
        if (this.extraNavClasses) {
          this.extraNavClasses = "";
          navbarColor.classList.add("md-primary");
        }
      }
    },
    scrollListener() {
      // resizeThrottler(this.handleScroll);
    },
    scrollToElement() {
      let element_id = document.getElementById("downloadSection");
      if (element_id) {
        element_id.scrollIntoView({ block: "end", behavior: "smooth" });
      }
    }
  },
  mounted() {
    document.addEventListener("scroll", this.scrollListener);

    if(localStorage.getItem('member_id') && localStorage.getItem('user_type') == 'member'){
      this.is_login = true;
    }

    eventHub.$on('user_login', ()=>{
      this.is_login = true;
    });

  },
  beforeDestroy() {
    document.removeEventListener("scroll", this.scrollListener);
  }
};
</script>

<style lang="scss">
.md-list-item .md-list-item-content a {
  font-size: 14px;
}
@media (max-width: 991px) {
  .md-toolbar.md-primary .md-title,
  .md-toolbar.md-primary .md-list .menu-item .md-list-item-content,
  .md-toolbar.md-primary .md-toolbar-toggle .icon-bar,
  .md-toolbar.md-primary,
  .md-toolbar.md-primary:hover,
  .md-toolbar.md-primary:focus {
    color: #3c4858 !important;
  }
}
</style>
